import { render, staticRenderFns } from "./SettingsMediaUpload.vue?vue&type=template&id=3c7ce5cb&"
import script from "./SettingsMediaUpload.vue?vue&type=script&lang=js&"
export * from "./SettingsMediaUpload.vue?vue&type=script&lang=js&"
import style0 from "./SettingsMediaUpload.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports